import dayjs from 'dayjs';
import { ICategory } from '../../../shared-interfaces/Notation/ICategory';
import { ICoreUser } from '../../../shared-interfaces/User/ICoreUser';
import { IUser } from '../../../shared-interfaces/User/IUser';
import { AlertStatus } from '../../../shared-types/Notation/AlertStatus';
import { NotationType } from '../../../shared-types/Notation/NotationType';

interface INotationFilters {
  notationTypes: NotationType[];
  alertStatus: AlertStatus[];
  category: ICategory | undefined;
  fromDate: Date | undefined;
  toDate: Date | undefined;
  createdBy: IUser | ICoreUser | undefined;
  studentId: IUser | ICoreUser | undefined;
  assignedTo: IUser | ICoreUser | undefined;
  onlyUnassigned: boolean;
}

export const emptyNotationFilters = (): INotationFilters => {
  return {
    notationTypes: [
      NotationType.Alert,
      NotationType.Update,
      NotationType.Encouragement,
      NotationType.DataInsight,
    ],
    alertStatus: [AlertStatus.Open, AlertStatus.Lowered],
    category: undefined,
    fromDate: dayjs().startOf('M').subtract(6, 'M').toDate(),
    toDate: undefined,
    createdBy: undefined,
    studentId: undefined,
    assignedTo: undefined,
    onlyUnassigned: false,
  };
};

export default INotationFilters;
